import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  AggregatedMarketData: null,
  AggregatedMarketImpressions: null,
  status: 'idle',
  error: null,
};

const dataSlice = createSlice({
  name: 'aggregatedMarket',
  initialState,
  reducers: {
    setAggregatedMarketData: (state, action) => {
      state.AggregatedMarketData = action.payload;
      state.status = 'succeeded';
    },
    setAggregatedMarketImpressionsData: (state, action) => {
      state.AggregatedMarketImpressions = action.payload; // Store the second API data
      state.status = 'succeeded';
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.status = 'failed';
    },
    setLoading: (state) => {
      state.status = 'loading';
    },
  },
});

export const { setAggregatedMarketData, setAggregatedMarketImpressionsData, setError, setLoading } = dataSlice.actions;
export default dataSlice.reducer;
